import { createNames } from "@ace/web-components/dist_lib/utils";
export const getAceBettingSlipNames = (id) => {
    return createNames(id, 'ACE-BETTING-SLIP', '____FULLY_SCROLLABLE', 'SLIP_BUTTON', 'PROCESSING_OVERLAY', 'NOTIFICATION_INDICATOR', 'NOTIFICATION_INDICATOR____CHANGE', 'DESKTOP_NAV', 'MOBILE_NAV', 'MOBILE_NAV____OPEN', 'SECTION', 'SECTION____VISIBLE', 'SECTION____CONTENT', 'SECTION____SLIP_CONTENT', 'SECTION____MY_BETS', 'SECTION____SUMMARY', 'REMOVE_ALL_BUTTON', 'CONTENT', 'CONTENT____EMPTY', 'SUB_NAV', 'PROFILE_BUTTON', 'SLIP_HEADER', 'CASHOUT_FILTER', 'FOOTER', 'SUCCESS_HEADER', 'ISLAND', 'ISLAND__BUTTONS', 'ISLAND____SINGLE_BUTTON', 'ISLAND____ANCHORED', 'ISLAND____COLLAPSIBLE', 'ISLAND__COLLAPSIBLE_CONTENT', 'ISLAND__COLLAPSIBLE_CONTENT__BLOCK', 'ISLAND__COLLAPSIBLE_CONTENT__BLOCK____QUOTE', 'ISLAND__COLLAPSIBLE_CONTENT__CHEVRON', 'ISLAND__COLLAPSIBLE_CONTENT__CHEVRON____OPEN', 'QUOTE_ACCEPTANCE_MODAL');
};
export const aceBettingSlipSlots = {
    SLIP_HEADER: 'slip-header',
    EMPTY_SLIP: 'empty-slip',
    SLIP: 'slip',
    MY_BETS: 'my-bets',
    SUMMARY: 'summary',
    SUCCESS: 'success',
    NUMPAD: 'numpad',
    ERROR_TOAST: 'error-toast',
    COMPLETION_BANNER: 'completion-banner',
    QUOTE_ACCEPTANCE_MODAL: 'quote-acceptance-modal',
    REMOVE_ALL: 'remove-all',
};
//# sourceMappingURL=ace-betting-slip.get-names.js.map
